import { useQuery } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import type { ICandidateResumeEntity } from '../types/CandidateResume';
import type { IGetCandidateResumePayload } from '../types/CandidateResume.parameters';

interface IUseGetCandidateResumeOptions {
  enabled?: boolean;
}

export const useGetCandidateResume = (
  payload: IGetCandidateResumePayload,
  options?: IUseGetCandidateResumeOptions,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery<ICandidateResumeEntity, Error>({
    queryKey: ['GET_CANDIDATE_RESUME', payload.professionalId, payload.postingId],
    queryFn: () => PermanentJobsService.getCandidateResume(payload),
    retry: false,
    enabled: options?.enabled ?? true,
  });

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
